export const INIT = "kyotech/sw/INIT";
export const UPDATE = "kyotech/sw/UPDATE";
export const RELOAD = "kyotech/sw/RELOAD";
